// Pastille de couleur de pôle (classe .pole-dot définie dans public/main.css).
export function PoleDot({ couleur, titre }: { couleur?: string | null; titre?: string | null }) {
  if (!couleur) return null;
  return <span className="pole-dot" style={{ background: couleur }} title={titre ?? undefined} />;
}
